/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useState} from "react";
import {service as FileUploadService} from "../Services/FileUploadService";
import {useEffectPromise} from "./EffectHooks";

export const useFileUpload = (fileUploadId) => {
    const [fileUpload, setFileUpload] = useState(null);
    
    const loadUploadFile = async (fileUploadId) => {
        try {
            return (await FileUploadService.GetFileUpload(fileUploadId))?.result ?? null;
        } catch (error) {
            console.log(error);
        }
        return null;
    }
    
    useEffectPromise(
        () => loadUploadFile(fileUploadId),
        setFileUpload,
        [fileUploadId],
        fileUploadId != null,
    )
    
    
    const downloadFile = () => {
        void FileUploadService.DownloadFile(fileUpload?.fileName, fileUploadId);
    }
    
    return [
        fileUpload,
        loadUploadFile,
        downloadFile,
    ]
    
}
